import styled from "styled-components";

export const SpanComment = styled.span`
    font-size: 0.8rem;
    border-radius: 10px;
    padding: 5px;
    margin-bottom: 16px;
    width: 100%;
    background: var(--header-color);
    color: var(--input-font-color);
`;

export const DivPostponement = styled.div`
    display: flex;
    align-items: center;
    text-decoration: line-through;
    color: var(--red);
    font-size: 0.8rem;
    cursor: pointer;
`;
